import { Component } from '@angular/core';

@Component({
  selector: 'psc-common-dialogs',
  templateUrl: './common-dialogs.component.html',
})
export class CommonDialogsComponent {

}

